/**
 * Created by Karol Kluska on 27.06.17.
 */

angular
  .module('app')
  .factory('OffersParser', OffersParser);

function OffersParser() {
  function parse(offers, viewType, roomGroupCategoryFilterId) {
    if (roomGroupCategoryFilterId) {
      offers = offers.filter(function(offer) {
        return offer.room_group_offer && offer.room_group_offer.roomGroupCategoryFilters.length && angular.isDefined(offer.room_group_offer.roomGroupCategoryFilters.find(rgcf => rgcf.id === roomGroupCategoryFilterId));
      });
    }

    if (typeof viewType === 'undefined' || viewType === null)
      viewType = 'rooms';

    if (viewType === 'rates') {
      var distinctRatePlans = [];
      angular.forEach(offers, function (item) {
        if (!Array.isArray(item.rateplans)) {
          return;
        }

        angular.forEach(item.rateplans, function (rateplan) {
          var parsedRoom = parseRoom(item.room_group_offer);
          var parsedRateplan = parseRateplan(rateplan);

          parsedRateplan.prices.map(price => price.roomId = parsedRoom.id);

          const id = distinctRatePlans.findIndex(d => d.rateplan.id === parsedRateplan.id);
          if (id === -1) {
            distinctRatePlans.push({ rateplan: parsedRateplan, rooms: [parsedRoom], addons: item.add_ons });
          } else {
            distinctRatePlans[id].rooms.push(parsedRoom);
            distinctRatePlans[id].rateplan.prices.push(...parsedRateplan.prices);
          }
        });
      });

      angular.forEach(distinctRatePlans, function (item) {
        item.rooms.sort(function (a, b) {
          return a.maxPersons - b.maxPersons
        });
      });

      return distinctRatePlans;
    }
    else if (viewType === 'rooms') {
      var result = [];
      angular.forEach(offers, function (offer) {
        if (!isValidRateplans(offer.rateplans) || !isValidRoom(offer.room_group_offer)) {
          return;
        }

        var room = parseRoom(offer.room_group_offer);
        var rateplans = parseRateplans(offer.rateplans);
        result.push({
          room: room,
          rateplans: rateplans,
          addons: offer.add_ons
        });
      });
      return result;
    }
  }

  function isValidRateplans(rateplans) {
    if (!angular.isArray(rateplans)) {
      return false;
    }

    return rateplans.length > 0;
  }

  function isValidRoom(room) {
    return angular.isObject(room) && Object.keys(room).length > 0;
  }

  function parseRoom(room) {
    return {
      id: parseInt(room.id, 10),
      availableUnits: parseInt(room.available_units, 10),
      name: room.name,
      description: room.description,
      minPersons: parseInt(room.min_persons, 10),
      maxPersons: parseInt(room.max_persons, 10),
      size: parseFloat(room.area),
      images: parseImages(room.images),
      equipments: parseEquipments(room.equipments),
      position: parseInt(room.sequence, 10)
    };
  }

  function parseImages(images) {
    var result = [];

    if (!angular.isArray(images)) {
      return result;
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      result.push({
        src: image.src,
        order: image.order
      });
    }
    result.sort(function (a, b) {
      return a.order - b.order;
    });
    return result;
  }

  function parseEquipments(equipments) {
    var result = [];

    if (!angular.isArray(equipments)) {
      return result;
    }

    for (var i = 0; i < equipments.length; i++) {
      var equipment = equipments[i];
      result.push({
        name: equipment.name,
        symbol: equipment.symbol
      });
    }
    return result;
  }

  function parseRateplans(rateplans) {
    var result = [];
    for (var i = 0; i < rateplans.length; i++) {
      var rateplan = parseRateplan(rateplans[i]);
      if (rateplan !== null) {
        result.push(rateplan);
      }
    }
    return result;
  }

  function parseRateplan(rateplan) {
    var prices = parseRateplanPrices(rateplan.price, rateplan.id);
    if (prices.length > 0) {
      return {
        id: parseInt(rateplan.id, 10),
        name: rateplan.name,
        description: rateplan.description,
        minStay: parseInt(rateplan.min_stay, 10),
        maxStay: parseInt(rateplan.max_stay, 10),
        cta: rateplan.cta,
        ctd: rateplan.ctd,
        prices: prices,
        images: parseImages(rateplan.images),
        breakfast: rateplan.breakfast,
        dinner: rateplan.dinner,
        lunch: rateplan.lunch,
        supper: rateplan.supper
      };
    }
    return null;
  }

  function parseRateplanPrices(prices) {
    var result = [];
    var i;
    for (i = 0; i < prices.length; i++) {
      var price = prices[i];
      if (price.price > 0) {
        result.push({
          personsCount: parseInt(price.persons_count.adult, 10),
          age_counts: price.persons_count.age_counts || [],
          price: parseFloat(price.price),
          discountPrice: parseFloat(price.discount_price) || parseFloat(price.price),
          regularFee: parseFloat(price.regular_fee) || 0
        });
      }
    }
    if (result.length > 0) {
      result.sort(function (a, b) {
        return a.personsCount - b.personsCount;
      });
      var minPersonsCount = result[0].personsCount;
      for (i = 1; i < minPersonsCount; i++) {
        result.unshift({
          personsCount: i,
          price: result[0].price,
          discountPrice: result[0].discountPrice,
          regularFee: result[0].regularFee
        });
      }
    }
    return result;
  }

  return {
    parse: parse
  };
}
